interface SiteConfig {
  siteTitle: string;
  siteTitleAlt: string;
  publisher: string;
  siteDescription: string;
  siteUrl: string;
  postsPerHomePage: number;
  postsPerPage: number;
  author: string;
  authorUrl: string;
  userTwitter: string;
  shortTitle: string;
  shareImage: string;
  shareImageWidth: number;
  shareImageHeight: number;
  siteLogo: string;
  backgroundColor: string;
  themeColor: string;
  copyright: string;
  keywords: string;
}

const config: SiteConfig = {
  siteTitle: 'Blog | Everlywell: Home Health Testing Made Easy',
  siteTitleAlt: 'Everlywell: Home Health Testing Made Easy', // This allows an alternative site title for SEO schema.
  publisher: 'Everlywell', // Organization name used for SEO schema
  siteDescription:
    'Read our blog to learn about health, wellness, and how at-home lab testing can help you. See our newest blog posts now.',
  siteUrl: 'https://www.everlywell.com', // Site domain. Do not include a trailing slash!
  postsPerHomePage: 10, // Number of posts shown on the 1st page of the index.js template (home page)
  postsPerPage: 10, // Number of posts shown on paginated pages
  author: 'Everlywell', // Author for RSS author segment and SEO schema
  authorUrl: 'https://www.everlywell.com/', // URL used for author and publisher schema, can be a social profile or other personal site
  userTwitter: '@everly_well', // Change for Twitter Cards
  shortTitle: 'Everlywell', // Used for App manifest e.g. Mobile Home Screen
  shareImage: '', // Open Graph Default Share Image. 1200x1200 is recommended
  shareImageWidth: 900, // Change to the width of your default share image
  shareImageHeight: 600, // Change to the height of your default share image
  siteLogo: '/logos/ew-mark-1024.png', // Logo used for SEO, RSS, and App manifest
  backgroundColor: '#e9e9e9', // Used for Offline Manifest
  themeColor: '#121212', // Used for Offline Manifest
  copyright: `Copyright © ${new Date().getFullYear()} Everlywell, Inc.`, // Copyright string for the RSS feed
  keywords:
    'home health testing, online blood test, online health test, at home blood test, at home lab test, blood test, urine test, saliva test, food intolerance test, food sensitivity test, fertility test, hormone testing, self testing',
};

export default config;
